import React from 'react'
import { l } from '@manychat/manyui'

import { ChannelType, ChannelTypeLabel } from 'common/core/constants/ChannelType'

export const ChannelsText = ({ connectedChannels }: { connectedChannels: ChannelType[] }) => {
  if (!connectedChannels.length) {
    return <span>{l.translate('You have no channels connected.')}</span>
  }
  if (connectedChannels.length === 1) {
    return (
      <span>
        {l.translate(
          'You have {connectedChannel} channel connected. It moves with you to the new plan.',
          { connectedChannel: ChannelTypeLabel[connectedChannels[0]] },
        )}
      </span>
    )
  }
  return (
    <span>
      {l.translate(
        'You have {connectedChannels} connected. You can always manage your channels in Settings.',
        {
          connectedChannels: connectedChannels
            .map((channel) => ChannelTypeLabel[channel])
            .join(', '),
        },
      )}
    </span>
  )
}
